import { CheerzApiLegal } from "@Types/api/legal";
import { LegalContent } from "@Types/legal";

export const convertLegalFromApiToContent = (
  apiResponse: CheerzApiLegal["response"]
): LegalContent[] => {
  return apiResponse.map((element) => {
    return {
      description: element.description,
      priority: element.priority,
      subTitle: element.sub_title,
    };
  });
};
